import { useCallback, useEffect, useState } from 'react';

/**
 * useCommandPalette — manages open/close state for the Command Palette (Cmd+K).
 *
 * Registers a global keydown listener that toggles the palette on
 * Cmd+K (macOS) or Ctrl+K (Windows/Linux).
 */
export function useCommandPalette() {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((prev) => !prev), []);

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        toggle();
      }
    }

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [toggle]);

  return { open, setOpen, toggle } as const;
}
